import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import styles from "./ModernFooter.module.scss";

const ModernFooter = () => {
  const { instance } = useMsal();
  const fullyear = new Date().getFullYear();
  const footerLinks = [
    {
      text: "Conditions of use and disclaimer",
      href: "https://tg.org.au/conditions-of-use-and-disclaimer",
    },
    {
      text: "Privacy policy",
      href: "https://tg.org.au/privacy-policy",
    },
    {
      text: "Licence agreement",
      href: "https://tg.org.au/license-agreement",
    },
    {
      text: "Copyright permission",
      href: "https://tg.org.au/copyright-permission",
    },
    {
      text: "Support and FAQ",
      href: "https://tg.org.au/faq",
    },
  ];

  return (
    <footer role="contentinfo" className={styles.modernFooter}>
      {/* Footer Links Section */}
      <div className={styles.footerLinksSection}>
        <div className={styles.footerContainer}>
          <nav aria-label="Footer Navigation">
            <ul className={styles.footerLinks}>
              {footerLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className={styles.footerLink}>
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

      {/* Copyright Section */}
      <div className={styles.copyrightSection}>
        <div className={styles.footerContainer}>
          <div className={styles.copyrightText}>
            <p>
              © {fullyear} Therapeutic Guidelines Limited. All rights reserved.
              <br />
              ABN 45 074 766 224
            </p>
          </div>
        </div>
      </div>

      {/* Hidden login for functionality */}
      <div
        id="hiddenlogin"
        style={{ display: "none" }}
        onClick={() => {
          instance.loginRedirect(loginRequest).catch((e) => {
            console.error(e);
          });
        }}
      >
        Login
      </div>
    </footer>
  );
};

export default ModernFooter;
